"use client";

import { useLocale, useTranslations } from "next-intl";
import { useSearchParams } from "next/navigation";
import { safeAuthNext } from "@/lib/auth-redirect";
import { useSiteFlavor } from "@/components/layout/site-flavor-provider";
import { internationalSignInUrl } from "@/lib/site-flavor";
import { OAuthButtons } from "./oauth-buttons";
import { OrDivider } from "./or-divider";

export function AuthMethods({ source }: { source: string }) {
  const { emailOnlyAuth } = useSiteFlavor();
  const t = useTranslations("auth");
  const locale = useLocale();
  const searchParams = useSearchParams();
  const nextPath = safeAuthNext(searchParams.get("next"), locale);

  if (emailOnlyAuth) {
    return (
      <div className="space-y-3 rounded-xl border border-line bg-surface-mute p-4">
        <p className="text-sm leading-relaxed text-ink-mute">{t("common.internationalOAuthHint")}</p>
        <a href={internationalSignInUrl(locale, searchParams.get("next") ? nextPath : undefined)} className="inline-flex min-h-11 w-full items-center justify-center rounded-full border border-line bg-surface px-4 py-2 text-center text-sm font-medium text-ink hover:bg-surface-dim focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-mint">
          {t("common.internationalOAuthLink")}
        </a>
      </div>
    );
  }
  if (process.env.NEXT_PUBLIC_OAUTH_ENABLED === "false") {
    return <p className="text-sm text-ink-mute">{t("signIn.oauthMigrationHint")}</p>;
  }
  return <><OAuthButtons source={source} /><OrDivider /></>;
}
